import React from 'react';

import './style.scss';

export interface NotificationProps {
  title?: string;
  children: React.ReactNode;
}

const Notification: React.FC<NotificationProps> = ({ title, children }) => (
  <div className="Notification">

    <div className="Notification__wrapper">
      <i className="icon icon-info" />
      {title && <span className="Notification__wrapper__title">{title}</span>}
    </div>

    <div className="Notification__content">{children}</div>

  </div>
);

export default Notification;
